export default __webpack_public_path__ + "static/char-s-45-en-423794b357e1d9e030a95030c1576a6b.png";